module.exports = __webpack_public_path__ + "img/allow.1afc0ff1.svg";